import React from 'react'

export default function Footer() {
  return (
    <div>
        <div style={{height:"0.5px",backgroundColor:"#00000026"}} ></div>
        <div className='py-5'>
            
            <div className='d-flex flex-column justify-content-center align-items-center py-5'>
                <p className='h5 mb-3'>Let's connect on</p>
                <div className='d-flex justify-content-center gap-4'>
                <p className='grey-text' style={{fontSize:"30px"}}><a href='mailto:couragebernard77@gmail.com'><i class="bi bi-envelope-fill"></i></a></p>
                <p className='grey-text' style={{fontSize:"30px"}}><a href='tel:+2348159702925'><i class="bi bi-telephone-fill"></i></a></p>
                <p className='grey-text' style={{fontSize:"30px"}}><a href='https://wa.link/088rl6'><i class="bi bi-whatsapp"></i></a></p>
                <p className='grey-text' style={{fontSize:"30px"}}><a href='https://facebook.com/bernardcourage.clyde.7'><i class="bi bi-facebook"></i></a></p>
                <p className='grey-text' style={{fontSize:"30px"}}><a href='https://twitter.com/Currie_Bee'><i class="bi bi-twitter"></i></a></p>
                <p className='grey-text' style={{fontSize:"30px"}}><a href='https://www.instagram.com/currie_drk/'><i class="bi bi-instagram"></i></a></p>
                <p className='grey-text' style={{fontSize:"30px"}}><a href='https://github.com/couragebernard'><i class="bi bi-github"></i></a></p>
                </div>
            </div>
            <p className='text-center'>© 2022 Courage Bernard. All Rights Reserved.</p>
        </div>
        
    </div>
  )
}
